/**
 * Member-gate number boxes: minimum account age and minimum reputation.
 *
 * An empty box is no minimum. A whole number above zero is that minimum. Anything
 * else is refused. It must never be saved as no minimum while the box still shows
 * a different value — that would let members earn a paid bounty the admin meant
 * to hold back.
 */

const WHOLE_NUMBER = /^[0-9]+$/;

/** Anything but digits never reaches the form, so the box cannot show text the save would drop. */
export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Blank or zero is no minimum (a zero-day or zero-point gate rules nobody out).
 * Any other text that is not a whole number throws, rather than coming back null.
 */
export function memberGateInt(text: string, label: string): number | null {
  const trimmed = text.trim();
  if (!trimmed) return null;
  const value = Number(trimmed);
  // A long digit string can exceed a safe integer. Refuse it rather than round it.
  if (!WHOLE_NUMBER.test(trimmed) || !Number.isSafeInteger(value)) {
    throw new Error(`${label} must be a whole number, or empty for no minimum.`);
  }
  return value > 0 ? value : null;
}
